import React, { useState, useEffect } from "react";
import "./Goals.css";
import { useNavigate } from "react-router-dom";
import Alert from "../../Components/Alert/Alert";
import AnswerOption from "../../Components/AnswerOption/AnswerOption";

export default function Goals() {
  const navigate = useNavigate();
  const initialGoals = [
    { label: "LOSS", title: "کاهش وزن", isChecked: false },
    { label: "GAIN", title: "اضافه کردن وزن", isChecked: false },
    { label: "MUSCLE", title: "عضله سازی", isChecked: false },
    { label: "FITNESS", title: "حفظ کردن تناسب اندام", isChecked: false },
  ];
  const [goals, setGoals] = useState(initialGoals);
  const [selectedGoal, setSelectedGoal] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    const savedGoal = JSON.parse(localStorage.getItem("goal")) || "";
    if (savedGoal) {
      handleCheckboxChange(savedGoal);
    }
  }, []);

  const handleCheckboxChange = (goalLabel) => {
    const updatedGoals = goals.map((goal) => ({
      ...goal,
      isChecked: false,
    }));

    const updatedGoal = goals.find((goal) => goal.label === goalLabel);
    if (updatedGoal) {
      updatedGoal.isChecked = true;
    }

    setGoals(updatedGoals);
    setSelectedGoal(goalLabel);
  };

  const nextBtnHandler = () => {
    if (selectedGoal === "") {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    } else {
      navigate("/activities", { state: { goal: selectedGoal } });
      localStorage.setItem("goal", JSON.stringify(selectedGoal));
    }
  };

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay centeredFlex">
        <div className="userQuestionnaire">
          <div className="userQuestionnaireTop goalsTop">
            <h3 className="goalsHeading">هدف شما ؟</h3>
            <ul className="answerOptionsList">
              {goals.map((goal) => (
                <li key={goal.label} className="answerOptionItem">
                  <AnswerOption
                    optionTitle={goal.title}
                    optionKey={goal.label}
                    selectedOption={selectedGoal}
                    onCheck={(goalLabel) => handleCheckboxChange(goalLabel)}
                  />
                </li>
              ))}
            </ul>
          </div>
          <div className="userQuestionnaireBottom centeredFlex">
            <Alert
              showAlert={showAlert}
              alertText="لطفا یکی از اهداف خود را انتخاب کنید"
              bottom="5rem"
            />
            <div className="goalsNextWrapper">
              <button className="nextQuestion" onClick={nextBtnHandler}>
                بعدی
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
